import { render, staticRenderFns } from "./ResumoImagens.vue?vue&type=template&id=49fd52ea&"
import script from "./ResumoImagens.vue?vue&type=script&lang=js&"
export * from "./ResumoImagens.vue?vue&type=script&lang=js&"
import style0 from "./ResumoImagens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports